import { useEffect } from 'react';

export function useGoogleAnalytics(measurementId: string | undefined) {
  useEffect(() => {
    // Prevent duplicate script injection
    if (!measurementId || document.getElementById('google-tag')) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    script.id = 'google-tag';
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}');
    `;
    document.head.appendChild(inlineScript);
  }, [measurementId]);
}
